angular.module("ainapp")
    .controller("bulkSalesReturnController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            //            $scope.PageName = "Bulk Delivery Note";
            //            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            //            if ($scope.TokenInfo == null) {
            //                $state.go("login");
            //            } else {
            //                $scope.checkUserPageAccess($scope.PageName);
            //            }

            $scope.Init = function () {

                $scope.VoucherList = [];


            }
            $scope.Init();


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    $scope.VoucherList = [];

                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);
                        //.replace(/-/g, "/");
                        angular.forEach(oJS, function (e) {

                            var voucher = {
                                Date: e.Date,
                                CustomerCode: e.Code,
                                CustomerName: e.CustomerName,
                                VoucherNo: e.VoucherNo,
                                Remarks: e.Remarks,
                                LinkedRefNos: e.LinkedRefNos,
                                CurrencyName: e.Currency,
                                ProductCode: e.ProductCode,
                                ProductName: e.ProductName,
                                Description: e.Description,
                                Quantity: parseFloat(e.Quantity),
                                UnitName: e.Unit,
                                UnitPrice: parseFloat(e.UnitPrice),
                                Discount: parseFloat(e.Discount),
                                VatType: e.VatType,
                                VAT: parseFloat(e.VAT),
                                OtherCharges: parseFloat(e.OtherCharges),
                                ExtraCharges: parseFloat(e.ExtraCharges),
                            }

                            $scope.VoucherList.push(voucher);
                        });


                        $scope.$apply();
                    });
                };

                reader.readAsBinaryString(oFile);
            }



            $scope.uploadProducts = function () {

                var temp = "";
                angular.forEach($scope.VoucherList, function (e) {

                    if (e.Date == null || e.Date == "" || e.Date == undefined) {
                        temp = "Date Invalid";
                    } else if (e.CustomerName == null || e.CustomerName == "" || e.CustomerName == undefined || e.CustomerCode == null ||
                        e.CustomerCode == "" || e.CustomerCode == undefined) {
                        temp = "Customer Details Invalid";
                    } else if (e.VoucherNo == null || e.VoucherNo == "" || e.VoucherNo == undefined) {
                        temp = "Voucher No Invalid";
                    } else if (e.CurrencyName == null || e.CurrencyName == "" || e.CurrencyName == undefined) {
                        temp = "Currency Invalid";
                    } else if (e.ProductCode == null || e.ProductCode == "" || e.ProductCode == undefined || e.ProductName == null ||
                        e.ProductName == "" || e.ProductName == undefined) {
                        temp = "Customer Details Invalid";
                    } else if (!e.Quantity > 0) {
                        temp = "Quantity Invalid";
                    } else if (e.UnitName == null || e.UnitName == "" || e.UnitName == undefined) {
                        temp = "Unit Invalid";
                    } else if (!e.UnitPrice > 0) {
                        temp = "Unit Price Invalid";
                    } else if (e.VatType == null || e.VatType == "" || e.VatType == undefined) {
                        temp = "Vat Type Invalid";
                    } else if (!e.VAT > 0) {
                        temp = "VAT Invalid";
                    }
                })

                if (temp == 1) {
                    toastr.warning(temp);
                } else {

                    var salesinvs = [];

                    angular.forEach($scope.VoucherList, function (e) {

                        var olddata = null;
                        angular.forEach(salesinvs, function (ee) {
                            if (ee.VoucherNo == e.VoucherNo) {
                                olddata = ee;
                            }
                        })

                        if (olddata == null) {
                            var sales = {
                                DateString: e.Date,
                                CustomerCode: e.CustomerCode,
                                CustomerName: e.CustomerName,
                                VoucherNo: e.VoucherNo,
                                LinkedRefNos: e.LinkedRefNos,
                                Remarks: e.Remarks,
                                CurrencyName: e.Currency,
                                SaleInvoiceUploadDetails: [],
                            }
                            var det = {
                                ProductCode: e.ProductCode,
                                ProductName: e.ProductName,
                                Description: e.Description,
                                Quantity: e.Quantity,
                                UnitName: e.UnitName,
                                UnitPrice: e.UnitPrice,
                                Discount: e.Discount,
                                VatType: e.VatType,
                                VAT: e.VAT,
                                OtherCharges: e.OtherCharges,
                                ExtraCharges: e.ExtraCharges,
                            }
                            sales.SaleInvoiceUploadDetails.push(det);
                            salesinvs.push(sales);
                        } else {
                            var det = {
                                ProductCode: e.ProductCode,
                                ProductName: e.ProductName,
                                Description: e.Description,
                                Quantity: e.Quantity,
                                UnitName: e.UnitName,
                                UnitPrice: e.UnitPrice,
                                Discount: e.Discount,
                                VatType: e.VatType,
                                VAT: e.VAT,
                                OtherCharges: e.OtherCharges,
                                ExtraCharges: e.ExtraCharges,
                            }
                            olddata.SaleInvoiceUploadDetails.push(det);
                        }


                    })

                    console.log(salesinvs);

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.UploadSalesReturn(salesinvs).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.warning(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }


            }



        }])
